import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app.store";
import { IConfirmCheckoutResponseModel, OrderState } from "./order.models";

export const orderSlice = createSlice({
  name: "order",
  initialState: {
    confirmCheckoutSuccessModel: undefined,
  } as OrderState,
  reducers: {
    setConfirmCheckoutSuccessModel(
      state,
      action: PayloadAction<IConfirmCheckoutResponseModel>
    ) {
      state.confirmCheckoutSuccessModel = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { setConfirmCheckoutSuccessModel } = orderSlice.actions;
export const selectBranches = (state: RootState) => state.branch.branches;
